"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _listingType = _interopRequireDefault(require("./listing-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BreadcrumbLabels = {
  [_listingType.default.SALES_RESIDENTIAL.name]: {
    browse: 'Buy',
    search: 'Residential Sales Search'
  },
  [_listingType.default.RENTAL_RESIDENTIAL.name]: {
    browse: 'Rent',
    search: 'Residential Rentals Search'
  },
  [_listingType.default.RENTAL_COMMERCIAL.name]: {
    browse: 'Rent',
    search: 'Commercial Rentals Search'
  },
  [_listingType.default.SALES_COMMERCIAL.name]: {
    browse: 'Buy',
    search: 'Commercial Sales Search'
  },
  [_listingType.default.SALES_BUSINESS.name]: {
    browse: 'Buy',
    search: 'Business Sales Search'
  },
  [_listingType.default.SHARE_RESIDENTIAL.name]: {
    browse: 'Share',
    search: 'Residential Shares Search'
  },
  [_listingType.default.DEVELOPMENTS_RESIDENTIAL.name]: {
    browse: 'New Homes',
    search: 'New Homes Search'
  },
  [_listingType.default.SALES_EARLY_ACCESS.name]: {
    browse: 'Buy',
    search: 'Residential Sales Search'
  }
};
var _default = exports.default = BreadcrumbLabels;